import { render, staticRenderFns } from "./DistributionActivityRecordList.vue?vue&type=template&id=b18e1518&scoped=true&lang=pug&"
import script from "./DistributionActivityRecordList.vue?vue&type=script&lang=ts&"
export * from "./DistributionActivityRecordList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18e1518",
  null
  
)

export default component.exports